import Card from '@molecules/Card/Card';
import PropTypes from 'prop-types';

function ErrorMessage({ message = '' }) {
  return (
    <Card modifier="error">
      <p data-cy="error-message">{message}</p>
    </Card>
  );
}

function DisplayError({ error }) {
  if (!error || !error.message) return null;
  if (error.networkError?.result?.errors?.length) {
    return error.networkError.result.errors.map(error => (
      <ErrorMessage
        key={error.message}
        message={error.message.replace('GraphQL error: ', '')}
      />
    ));
  }

  if (error.graphQLErrors?.length) {
    return error.graphQLErrors.map(graphQLError => {
      if (graphQLError.debugMessage) {
        return (
          <ErrorMessage
            key={graphQLError.message}
            message={graphQLError.debugMessage}
          />
        );
      }

      const messages = graphQLError.message.split('\n');

      return messages.map(message => (
        <ErrorMessage
          key={message}
          message={message.replace('GraphQL error: ', '')}
        />
      ));
    });
  }

  if (error.response?.status === 404) {
    return (
      <ErrorMessage message="De data die wordt opgevraagd lijkt niet te bestaan." />
    );
  }

  if (error.message) {
    return <ErrorMessage message={`${error.message.replace('Error: ', '')}`} />;
  }

  return (
    <ErrorMessage
      message={`Er gaat iets mis met het ophalen van de data. ${
        error.response?.status ? `(${error.response.status})` : ''
      }`}
    />
  );
}

ErrorMessage.propTypes = {
  message: PropTypes.string,
};

DisplayError.propTypes = {
  // eslint-disable-next-line react/require-default-props
  error: PropTypes.shape({
    message: PropTypes.string,
    response: PropTypes.shape({
      status: PropTypes.number,
    }),
    networkError: PropTypes.shape({
      result: PropTypes.shape({
        errors: PropTypes.arrayOf(
          PropTypes.shape({
            debugMessage: PropTypes.string,
            message: PropTypes.string,
          })
        ),
      }),
    }),
    graphQLErrors: PropTypes.arrayOf(
      PropTypes.shape({
        debugMessage: PropTypes.string,
        message: PropTypes.string,
      })
    ),
  }),
};

export default DisplayError;
